exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".showAllButton[data-v-62e74877] {\n  font-size: x-small;\n  padding: 0;\n}\n.collapsed > .when-open[data-v-62e74877],\n:not(.collapsed) > .when-closed[data-v-62e74877] {\n  display: none;\n}", ""]);

// exports
